/* eslint-disable @typescript-eslint/explicit-member-accessibility */
export class RefreshTokenRequest {
    public RefreshToken: string;
  
    constructor(refreshToken: string) {
      this.RefreshToken = refreshToken;
    }
  }
  